import { connect } from 'react-redux';
import EventDetails from '../../../components/event/event-details';
import {
    fetchEventThunk,
    resetEvent,
    setEventSuccessMessage,
    deleteEventThunk,
    clearAllErrors,
    fetchEventPDFThunk,
    getLeadCountThunk,
    setFormPristine
} from '../../../actions';

import { getEventLoading } from '../../../reducers';

const mapStateToProps = state => ({
    groupStatus: state.events.groupStatus.status,
    groupSubStatus: state.events.groupStatus.subStatus,
    status: state.events.status,
    contract: state.forms.event.contract,
    eventId: state.events.id,
    tasks: state.events.tasks,
    rejectComments: state.events.rejectComments,
    updatedAt: state.events.updatedAt,
    updatedBy: state.events.updatedBy,
    userInfo: state.data.userInfo,
    startDate: state.events.startDate,
    successMessage: state.events.successMessage,
    errorMessage: state.events.errorMessage,
    hasActions: state.events.hasActions,
    userIsCreator: state.events.userIsCreator,
    tabOneValid: state.events.validTabOne,
    tabTwoValid: state.events.validTabTwo,
    eventName: state.events.name,
    eventSaveSubmit: state.events.eventSaveSubmit,
    prAccessible: state.events.prAccessible,
    prInfo: state.events.prInfo,
    aaRequestMessage: state.events.aaRequestMessage,
    aaTasks: state.events.aaTasks,
    jwtToken: state.auth.jwtToken,
    getEventLoading: getEventLoading(state),
    sourceCode: state.event.sourceCode,
    eacCode: state.event.eacCode,
    handheld: state.event.isFromEac,
    modalLeadCount: state.events.modalLeadCount,
    leadCount: state.events.leadCount,
    formSaved: state.events.formSaved,
    formTouched: state.forms.event.$form.touched
});

const mapDispatchToProps = dispatch => ({
    fetchEvent: (e, history) => dispatch(fetchEventThunk(e, history)),
    resetEvent: () => dispatch(resetEvent()),
    clearMessage: () => dispatch(setEventSuccessMessage(null)),
    deleteEvent: data => dispatch(deleteEventThunk(data)),
    clearAllErrors: () => dispatch(clearAllErrors()),
    fetchEventPDF: id => dispatch(fetchEventPDFThunk(id)),
    getLeadCountThunk: () => dispatch(getLeadCountThunk()),
    setFormPristine: () => dispatch(setFormPristine())
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EventDetails);



// WEBPACK FOOTER //
// ./src/containers/event/event-details/index.js